module.exports = __webpack_public_path__ + "img/sec8mob.513906b8.png";